var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_880_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0581 4.16282C12.2511 4.92982 11.0631 6.61582 11.0021 8.54282L11.0001 8.72482L10.7571 8.70182C8.36508 8.43282 6.25908 7.18982 4.81308 5.17082C4.71517 5.03398 4.58431 4.92407 4.43262 4.85125C4.28094 4.77843 4.11333 4.74506 3.94532 4.75424C3.77732 4.76341 3.61434 4.81483 3.47148 4.90373C3.32863 4.99263 3.21051 5.11614 3.12808 5.26282L3.03108 5.44882L2.98208 5.54782C2.26308 7.03282 1.79208 8.83782 1.96508 10.7508L1.99508 11.0238C2.27808 13.2868 3.49508 15.2388 5.77408 16.7028L5.94708 16.8098L5.86608 16.8528C4.55108 17.5158 3.34808 17.8048 2.03908 17.7528C0.98308 17.7128 0.59308 19.1248 1.52108 19.6308C5.11908 21.5918 8.98208 22.1968 12.3131 21.2308C16.3731 20.0508 19.4651 17.0078 20.6481 12.7978L20.7751 12.3028C21.0131 11.3098 21.1471 10.2968 21.1761 9.27882L21.1791 8.94682L21.5721 8.16782L22.0121 7.30582L22.2261 6.87182L22.3441 6.62482C22.6091 6.05982 22.8001 5.59182 22.9181 5.19482L22.9321 5.13882L22.9401 5.12082C23.1601 4.52782 22.7741 3.76282 21.9991 3.76282L21.8771 3.76982C21.7981 3.77953 21.7205 3.79867 21.6461 3.82682L21.5601 3.86482C21.2747 4.00341 20.9808 4.12365 20.6801 4.22482L20.3241 4.33982L20.0531 4.41982L19.2811 4.63382C17.9451 3.51582 16.1371 3.37982 14.2691 4.07982L14.0581 4.16282Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_880_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.75293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d207adef224bc02a21365faa273b97b9.svg";
export { ForwardRef as ReactComponent };